import { Fragment } from "react";

const fontSizes = {
  small: "12px",
  medium: "14px",
  large: "16px",
};

export const Text = ({
  children,
  size = "medium",
  as: As = "span",
  center,
}: {
  children: React.ReactNode;
  size?: "small" | "medium" | "large";
  as?: React.ElementType | typeof Fragment;
  center?: boolean;
}) => {
  return (
    <As
      style={{
        fontSize: fontSizes[size],
        textAlign: center ? "center" : undefined,
        margin: center ? "0 auto" : undefined,
      }}
    >
      {children}
    </As>
  );
};
